export default __webpack_public_path__ + "static/media/kitchen5-afterA-1920w.a0ef97b0.webp";